import React from 'react';

const top = (props) => {
	return(
            <svg x="0px" y="0px" viewBox="-60 -20 670 600" 
                 style={{marginLeft: '5px',marginTop: '7px'}}>
                <rect x="344.276" y="335.448" style={{fill:'#FFDC13'}} width="167.724" height="176.552"/>
                <rect x="167.724" y="176.552" style={{fill:'#FFA511'}} width="176.552" height="335.448"/>
                <rect y="335.448" style={{fill:'#FFDC13'}} width="167.724" height="176.552"/>
                <g>
                    <path style={{fill:'#FFA511'}}  d="M229.517,114.759c-0.821,0-1.633-0.115-2.428-0.335c-40.28-11.661-68.052-48.481-68.193-90.412
                        v-6.356c0-4.873,3.955-8.828,8.828-8.828h26.483c4.873,0,8.828,3.955,8.828,8.828s-3.955,8.828-8.828,8.828h-17.655
                        c1.183,33.13,23.508,61.749,55.358,70.956c4.687,1.333,7.415,6.215,6.082,10.902C236.915,112.128,233.454,114.75,229.517,114.759z"
                        />
                    <path style={{fill:'#FFA511'}} d="M282.483,114.759c-4.873,0.009-8.836-3.937-8.845-8.81c-0.009-3.955,2.613-7.433,6.418-8.51
                        c31.859-9.19,54.21-37.817,55.393-70.956h-17.655c-4.873,0-8.828-3.955-8.828-8.828s3.955-8.828,8.828-8.828h26.483
                        c4.873,0,8.828,3.955,8.828,8.828v6.356c-0.141,41.931-27.913,78.751-68.193,90.412
                        C284.116,114.644,283.304,114.759,282.483,114.759z"/>
                </g>
                <path style={{fill:'#FFDC13'}} d="M229.517,88.276L229.517,88.276c-22.607-22.607-35.31-53.274-35.31-85.248V0h123.586v3.028
                    c0,31.974-12.703,62.641-35.31,85.248H229.517z"/>
                <path style={{fill:'#E5AF17'}} d="M220.566,78.159c2.79,3.54,5.782,6.912,8.951,10.116h52.966
                    c19.968-19.986,32.274-46.354,34.781-74.496C296.678,49.002,260.996,72.757,220.566,78.159z"/>
                <rect x="238.345" y="114.759" style={{fill:'#²FFA511'}} width="35.31" height="26.483"/>
                <polygon style={{fill:'#FFDC13'}} points="229.517,88.276 229.517,105.931 238.345,114.759 273.655,114.759 282.483,105.931 
                    282.483,88.276 "/>
                <rect x="220.69" y="158.897" style={{fill:'#E5AF17'}}  width="70.621" height="17.655"/>
                <polygon style={{fill:'#FFDC13'}}  points="238.345,141.241 220.69,158.897 291.31,158.897 273.655,141.241 "/>
                <path style={{fill:'#E5AF17'}}  d="M344.276,399.122V512H512V335.448h-74.461C408.161,359.08,376.982,380.372,344.276,399.122z"/>
                <path style={{fill:'#F08015'}}  d="M167.724,471.393V512h176.552V399.122C288.918,430.989,229.535,455.3,167.724,471.393z"/>
                <path style={{fill:'#E5AF17'}}  d="M0,494.009V512h167.724v-40.607C112.896,485.491,56.602,493.082,0,494.009z"/>
            </svg>
            );
}
export default top;


// WEBPACK FOOTER //
// ./src/Components/GameInfo/TopPlayers/TopSVG/TopSVG.js